import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpotlightResponseFooterComponent } from '../shared/response-footer/response-footer.component';
import { getMonetaryIcon, formatCurrencyBRL } from './result-monetary.constants';

@Component({
    selector: 'spotlight-result-monetary',
    standalone: true,
    imports: [
        CommonModule,
        SpotlightResponseFooterComponent
    ],
    templateUrl: './result-monetary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpotlightResultMonetaryComponent {
    @Input() title: string = '';
    @Input() description: string = '';
    @Input() value: number | string = 0;
    @Input() executionTimeMs: number = 0;

    getIcon(): string {
        return getMonetaryIcon(this.title);
    }

    getFormattedValue(): string {
        return formatCurrencyBRL(this.value);
    }
}
